import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "google-map",
  "use": "google-map-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"google-map\"><g clip-path=\"url(#google-map_clip0_2_63)\"><rect width=\"16\" height=\"16\" rx=\"2\" fill=\"#D9453D\" /><path d=\"M11.356 6.624a3.5 3.5 0 10-6.804-.837C4.606 7.27 6 9 6 9c1.5 2 2 4.6 2 5 0-.4.5-3 2-5 0 0 .99-1.142 1.356-2.376z\" fill=\"#fff\" /></g><defs><clipPath id=\"google-map_clip0_2_63\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol